import React, { Component } from 'react';
import utils from "../../utils/utils";
import './style.less';

class PipelineBrand extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  // 图片跳转
  productBannerGo = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const options = {
      link: item.link,
      title: 4,
      sort: index
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,item.link, options, -1,this.props,false);
  
  }

  render() {
    const { comBgColor, comBodyColor } = this.props.config
    const { componentDivideLine } = this.props
    return (
      <div className="pipeline-brand" style={{backgroundColor: comBgColor}} {...this.props['customAttributes']}>
        <div className="title-img">
          <img src={utils.formatImgUrl(this.props.config.titleImage, this.props.webpSupport)} />
        </div>
        <div className="brand-body" style={{backgroundColor: comBodyColor}}>
          {
            this.props.config.itemRows.map((rowItems, rowIndex) => {
              return (
                <div key={`brand-row-${rowIndex}`} className="brand-content">
                  {
                    rowItems.map((item, index) => {
                      return (
                        <div className="img-item" key={`brand-${index}`}><img src={utils.formatImgUrl(item.img, this.props.webpSupport)} onClick={this.productBannerGo.bind(this, item, index)} /></div>
                      )
                    })
                  }
                </div>                  
              )
            })
          }
        </div>
        {this.props.notLastItem && componentDivideLine && (
          <img 
            className="component-divide-line" 
            src={utils.formatImgUrl(componentDivideLine, this.props.webpSupport)}
          />
        )}
      </div>
    );
  }
}

export default PipelineBrand;



// WEBPACK FOOTER //
// ./components/pipeline-brand/index.jsx